import { render, staticRenderFns } from "./TeamsComponent.vue?vue&type=template&id=6f77edec&"
import script from "./TeamsComponent.vue?vue&type=script&lang=js&"
export * from "./TeamsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports